
import ContactEntity from '~/lib/entities/contact'

export default {
  name: 'FormContact',

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    compModel: {
      // Don't use v-model with a vuex store
      set(newValue) {
        this.$emit('input', newValue)
      },

      get() {
        return this.value
      }
    },

    compValidations() {
      return new ContactEntity().validation
    },

    compTypeOptions() {
      const types = [
        'Booking enquiry',
        'Reschedule / Cancel a booking',
        'Marketing',
        'Land owners',
        'Feedback / complaint'
      ]

      return types.map(type => ({
        label: type,
        value: type
      }))
    },

    compIsLandOwnerEnquiry() {
      return this.compModel.type === 'Land owners'
    },

    compPaddockOptions() {
      const options = [{ label: 'No', value: 'No' }]

      this.$store.getters['paddocks/all'].forEach(paddock => {
        options.push({
          label: paddock.name,
          value: paddock.name
        })
      })

      return options
    }
  },

  created() {
    this.compModel = new ContactEntity({ ...this.value }).model

    this.$store.dispatch('paddocks/fetchAll')
  }
}
